import type { AppThunk } from "src/store";
import { fetchWrapper } from "src/utils/fetch-wrapper";
import { api } from "src/config";
import { InstagramGeneratedData } from "src/types/analysis";

const analyzeInstagram =
  (username: string): AppThunk =>
  async (dispatch): Promise<void> => {
    var result = await fetchWrapper.post(`${api}/instagram`, {
      username: username,
    });

    return result;
  };

const updateInstagramProfile =
  (id: string, profile: InstagramGeneratedData): AppThunk =>
  async (dispatch) => {
    var result = await fetchWrapper.put(`${api}/instagram/${id}`, profile);

    return result;
  };

const getInstagramProfile =
  (username: string): AppThunk =>
  async (dispatch): Promise<void> => {
    var result = await fetchWrapper.get(`${api}/instagram/${username}`, {});

    return result;
  };

const getInstagramVideoTranscription =
  (url: string): AppThunk =>
  async (dispatch): Promise<string> => {
    const data = await fetchWrapper.post(`${api}/video-to-text/instagram`, {
      url,
    });

    return data;
  };

export const thunks = {
  analyzeInstagram,
  getInstagramProfile,
  updateInstagramProfile,
  getInstagramVideoTranscription,
};
